import React, { Component } from 'react'
import { ReactComponent as Facebook } from './facebook.svg'
import { ReactComponent as instagram } from './instagram.svg'
import { ReactComponent as pinterest } from './pinterest.svg'
import { ReactComponent as twitter } from './twitter.svg'
import { ReactComponent as youtube } from './youtube.svg'
import Link from './Link'
import { extend } from '../../../../../utils/classes'

export class Social extends Component {
  links = [
    {
      name: 'facebook',
      Icon: Facebook,
    },
    {
      name: 'instagram',
      Icon: instagram,
    },
    {
      name: 'pinterest',
      Icon: pinterest,
    },
    {
      name: 'twitter',
      Icon: twitter,
    },
    {
      name: 'youtube',
      Icon: youtube,
    },
  ]

  baseClass = extend(this.props.parentClass, 'social')

  renderLinks = () =>
    this.links.map((linkData, index) => (
      <Link {...linkData} key={index} parentClass={this.baseClass} />
    ))

  render() {
    return <ul className={this.baseClass}>{this.renderLinks()}</ul>
  }
}

export default Social
